<template>
  <div class="videoplay">
    <!-- 搜素 -->
    <div class="search-cancel">
      <input
        v-model="keyword"
        type="text"
        placeholder="搜索"
        class="input"
        @keyup.enter="handleKeyUp()"
      >
      <mt-button
        type="primary"
        size="small"
        @click="cancel"
      >取消</mt-button>
    </div>
    <!-- 播放器 -->
    <div class="player">
      <video-player
        class="video-player vjs-custom-skin"
        ref="videoPlayer"
        :playsinline="true"
        :options="playerOptions"
      ></video-player>
    </div>
    <!-- 导航 -->
    <mt-navbar v-model="selected">
      <mt-tab-item id="1">详情</mt-tab-item>
      <mt-tab-item id="2">目录</mt-tab-item>
    </mt-navbar>
    <!-- 导航对应的内容 -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="1">
        <div class="main">
          <p class="title">{{courseInfo.courseName}}</p>
          <p class="content">{{courseInfo.describe}}</p>
        </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="2">
        <div class="videolist">
          <div class="vname">视频</div>
          <div
            @click="handleVideo(item.vid)"
            class="item"
            v-for="(item, index) in currentPageList"
            :key="index"
          >{{item.vName}}</div>
        </div>
        <div class="page">
          <p>
            <span
              class="left"
              @click="prev"
            ></span>
            <span
              class="right"
              @click="next"
            ></span>
          </p>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import { MessageBox } from "mint-ui";
import moment from "moment";
export default {
  data() {
    return {
      keyword: "",
      selected: "1",
      pageindex: 1,
      courseId: this.$route.query.courseId,
      imgSrc: this.$route.query.imgSrc,
      videoList: [],
      courseInfo: {},
      baseUrl: 'https://m.teleicu.cn/',
      // baseUrl: "http://192.168.199.193:3607/", //服务器地址
      coverUrl: "",
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "",
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        height: 210,
        // width: 200,
        // width: document.documentElement.clientWidth,
        notSupportedMessage: "请点击下方视频列表进行播放", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      currentPageList: [], //当前页渲染的视频列表
      currentPage: 1,
      pagesize: 5
    };
  },
  created() {
    this.getAllVedioList();
    //视频封面
    this.playerOptions.poster = this.baseUrl + this.imgSrc;
    this.setScreen(".videoplay");
  },
  methods: {
    // 取消
    cancel() {
      this.keyword = "";
      this.getAllVedioList();
    },
    // 前端实现模糊查询
    handleKeyUp() {
      let searchList = [];
      if (this.videoList.length <= 0) {
        Toast({
          message: "该课程下暂没视频!",
          position: "top",
          duration: 2500
        });
      } else {
        this.currentPageList = [];
        var reg = new RegExp(this.keyword);
        for (let item of this.videoList) {
          if (item.vName.match(reg)) {
            searchList.push(item);
          }
        }
        this.currentPageList = searchList.concat();
        if (this.currentPageList.length <= 0) {
          Toast({
            message: "没有搜索到该视频!",
            position: "top",
            duration: 2500
          });
        }
      }
    },
    // 解决某些安卓端虚拟按键导致页面高度不够样式错乱
    setScreen(wrap) {
      // 文档高度
      let s_height = document.body.clientHeight;
      // 文档宽度
      let s_width = document.body.clientWidth;
      let proportion = s_height / s_width;
      if (proportion < 1.55) this.playerOptions.height = 150;
    },
    // 前端实现分页 上一页
    prev() {
      this.currentPage--
      if (this.currentPage < 1) {
        this.currentPage = 1;
        Toast({
          message: "已经是第一页了!",
          position: "top",
          duration: 2500
        });
        return;
      }
      let offset = (this.currentPage - 1) * this.pagesize;
      let pagesize = this.pagesize * this.currentPage;
      this.currentPageList = this.videoList.slice(offset, pagesize);
    },
    // 前端实现分页 下一页
    next() {
      this.currentPage++;
      let pageNum = Math.ceil(this.videoList.length / this.pagesize);
      if (this.currentPage > pageNum) {
        this.currentPage = pageNum;
        Toast({
          message: "已经是最后一页了!",
          position: "top",
          duration: 2500
        });
        return;
      }
      let offset = (this.currentPage - 1) * this.pagesize;
      let pagesize = this.pagesize * this.currentPage;
      this.currentPageList = this.videoList.slice(offset, pagesize);
    },
    // 获取当前分类下的所有视频
    getAllVedioList() {
      this.Axios.get(
        "/api/Education/GetEducationInfo?id=" + this.courseId
      ).then(res => {
        const data = res.data;
        if (data.status === 100) {
          let url = data.data.picture;
          this.playerOptions.autoplay = true;
          this.courseInfo = data.data;
          // debugger// 所有视频
          this.videoList = data.data.videos;
          // 当前页的视频
          this.currentPageList = this.videoList.slice(0, 5);
          if (this.videoList.length < 1) {
            Toast({
              message: "该课程下暂没视频!",
              position: "top",
              duration: 2500
            });
          }
        } else {
          Toast({
            message: data.message,
            position: "top",
            duration: 1500
          });
        }
      });
    },
    // 点击播放视频
    handleVideo(vid) {
      this.Axios.get(
        "/api/Education/GetVideoPath?id=" + this.courseId + "&vid=" + vid
      ).then(res => {
        const data = res.data;
        if (data.status === 100) {
          this.playerOptions.sources[0].src = data.data[0];
        } else {
          Toast({
            message: data.message,
            position: "top",
            duration: 1500
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
.videoplay {
  height: 100%;
  background: #f5f5f9;
  .search-cancel {
    background: #efeff4;
    height: 32px;
    border-top: 1px solid #ccc;
    padding-left: 3%;
    padding-top: 10px;
    padding-bottom: 10px;
    .input {
      width: 67%;
      height: 30px;
      border: white;
      border-radius: 4px;
      text-align: center;
      outline: none;
    }
    .mint-button--small {
      height: 26px;
      margin-left: 4%;
    }
  }
  // .player {
  //   // height: 35%;/
  //   // border: 1px solid red;
  // }
  .mint-navbar {
    background: #f5f5f9;
    border-bottom: 1px solid #ccc;
    border-top: 1px solid #ccc;
    margin-top: 5px;
  }
  .main {
    font-size: 14px;
    padding: 10px;
    background: white;
    margin-top: 10px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 0;
      font-size: 16px;
      font-weight: 550;
      margin-bottom: 10px;
    }
    .content {
      margin: 0;
    }
  }
  .videolist {
    margin-top: 10px;
    .vname {
      font-size: 14px;
      font-weight: 550;
      background: #fafafa;
      padding: 10px 0 10px 30px;
      border-top: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
    }
    .item {
      font-size: 13px;
      padding: 14px 0 14px 10px;
      border-bottom: 1px solid #ccc;
      background: white;
      color: #6699ff;
    }
  }
  .page {
    text-align: center;
    p {
      width: 70px;
      display: inline-block;
      overflow: hidden;
      margin: 0;
      margin-top: 6px;

      .left {
        display: inline-block;
        height: 22px;
        width: 13px;
        background: url("../../assets/u1208.png") center center no-repeat;
        transform: rotateY(180deg);
        float: left;
      }
      .right {
        display: inline-block;
        height: 22px;
        width: 13px;
        background: url("../../assets/u1208.png") center center no-repeat;
        float: right;
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
